import React from "react";
import "./Universities.css";
import uk from './images/uk.jpeg';
import usa from './images/usa.avif';
import Ireland from './images/Ireland.jpg';
import Germany from './images/germany.jpg';
import australia from './images/aus.jpg';
import Canada from './images/canda.jpg';
import newzeland from './images/newzeland.jpg';
import switzerland from './images/switzerland.jpg';
import dubai from './images/dubai.jpg';
import singapore from './images/singapore.jpg';
import europe from './images/europe.jpg';
import russia from './images/russia.jpg';
import { Link } from "react-router-dom";

const universities = [
  { name: "Explore UK Universities", image: uk, l: "/countries/uk" },
  { name: "Explore USA Universities", image: usa, l: "/countries/us" },
  { name: "Explore Germany Universities", image: Germany, l: "/countries/Germany" },
  { name: "Explore Australia Universities", image: australia, l: "/countries/Australia" },
  { name: "Explore Canada Universities", image: Canada, l: "/countries/Canada" },
  { name: "Explore New Zealand Universities", image: newzeland, l: "/countries/newzeland" },
  { name: "Explore Ireland Universities", image: Ireland, l: "/countries/Ireland" },
  { name: "Explore Switzerland Universities", image: switzerland, l: "/countries/switzerland" },
  { name: "Explore Dubai Universities", image: dubai, l: "/countries/dubai" },
  { name: "Explore Singapore Universities", image: singapore, l: "/countries/singapore" },
  { name: "Explore Europe Universities", image: europe, l: "/countries/europe" },
  { name: "Explore Russia Universities", image: russia, l: "/countries/russia" },
];

const Universities = () => {
  return (
    <div className="universities-page">
      <h1 className="title">Universities</h1>
      <p className="subtitle">Choose your desired University from a wide range of list</p>
      <p className="description">
        Study in one of the top universities abroad <br />
        We have compiled a list of the best universities for you
      </p>

      <div className="universities-grid">
        {universities.map((uni, index) => (
          <Link to={uni.l} key={index}>
            <div className="university-card">
              <img src={uni.image} alt={uni.name} />
              <button className="explore-button">{uni.name}</button>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Universities;
